export const UUID = 'UUID';
export const USD = 'USD';

// Default slider settings
export const SLICK_SLIDER_SETTINGS = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1279,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        dots: true,
        arrows: true,
      },
    },
  ],
};
